import CompanyInfo from './CompanyInfo';
import TenantInactive from './TenantInactive';
import Licenses from './Licenses';
import useRequireAuth from '../../hooks/useRequireAuth';

function Status() {
  const data = useRequireAuth();

  if (!data || !data.tenant) {
    return null;
  }
  const tenantName = data && data.tenant && data.tenant.name;
  const tenantDomain = data && data.tenant && data.tenant.domain;
  const tenantId = data && data.tenant && data.tenant.id;
  const isActive = data && data.tenant && data.tenant.isActive;

  return !data || !data.tenant ? null : (
    <>
      <hr />
      <CompanyInfo
        tenantName={tenantName}
        tenantDomain={tenantDomain}
        tenantId={tenantId}
      />
      <TenantInactive isActive={isActive} />
      <Licenses />
    </>
  );
}

export default Status;
